import { getTintsWithOpacities, tintColors } from './colors'
import { SYSTEM_FONT } from './typography'

/**
 * Design tokens for Prism design system, separated from the original
 * ones so we can easily remove unused tokens in the future.
 *
 * For now it makes more sense to have them unified here as we are only
 * defining the ones that didn't exist before, but after the redesign is
 * launched it will probably make more sense to split them by theme.
 */

/**
 * Light theme is based on tint.3, color variables in the Sketch file won't
 * match these token values because in Sketch we use a combination of Tint +
 * Fill, but for CSS we just use one color.
 */
export const light = {
  colors: {
    background: {
      primary: {
        1: 'hsl(0, 0%, 0%)',
        2: 'hsla(0, 0%, 0%, .85)',
        3: 'hsla(0, 0%, 0%, .70)',
      },
      secondary: {
        1: 'hsl(0, 0%, 100%)',
        2: 'hsl(0, 0%, 98%)',
        3: 'hsl(0, 0%, 90%)',
      },
      tertiary: {
        1: 'hsla(0, 0%, 0%, .04)',
        2: 'hsla(0, 0%, 0%, .1)',
        3: 'hsla(0, 0%, 0%, .3)',
      },
    },
    foreground: {
      primary: {
        1: 'hsl(0, 0%, 100%)',
        2: 'hsla(0, 0%, 100%, .7)',
        3: 'hsla(0, 0%, 100%, .25)',
      },
      secondary: {
        1: 'hsl(0, 0%, 0%)',
        2: 'hsla(0, 0%, 0%, .85)',
        3: 'hsla(0, 0%, 0%, .7)',
        4: 'hsla(0, 0%, 0%, .55)',
      },
    },
    border: {
      1: 'hsla(0, 0%, 0%, .10)',
      2: 'hsl(0, 0%, 90%)',
    },
    shadow: {
      inner: 'hsla(0, 0%, 0%, .06)',
      outer: 'hsla(0, 0%, 0%, .10)',
    },
    state: {
      disabled: 'hsla(0, 0%, 0%, .30)',
      hover: 'hsla(0, 0%, 0%, .04)',
      positive: 'hsl(135, 82%, 41%)',
      negative: 'hsl(360, 100%, 40%)',
      warning: 'hsl(40, 89%, 44%)',
    },
    primaryTint: getTintsWithOpacities(tintColors.default),
    tint: tintColors,
  },
}

export const fontSizes = {
  xxlarge: '2rem', // 32px
  xlarge: '1.5rem', // 24px
  large: '1.25rem', // 20px
  body: '1rem', // 16px
  small: '0.875rem', // 14px
  smaller: '0.8125rem', // 13px
  little: '0.75rem', // 12px
  tiny: '0.6875rem', // 11px
  tinier: '0.625rem', // 10px

  // DEPRECATED VALUES: DO NOT USE THIS VALUE FOR PRISM DESIGNS
  micro: '0.5rem', // 8px
  xxxlarge: '5rem', // 80px
}

export const fonts = {
  body: `Marfa, ${SYSTEM_FONT}`,
  buttons: `Marfa, ${SYSTEM_FONT}`,
  formLabels: `Marfa, ${SYSTEM_FONT}`,
  headings: `Marfa, ${SYSTEM_FONT}`,
  primary: `Marfa, ${SYSTEM_FONT}`,
  monospace: 'Marfa Mono, monospace',
}

export const radii = {
  base: '4px',
  small: '3px',
  medium: '5px',
  large: '6px',
  xlarge: '8px',
  xxlarge: '12px',
  xxxlarge: '16px',
  rounded: '999px',
}
